import Vue from "vue";
import { dateFormat } from "./constants";
import { round } from "lodash";

Vue.filter("age", (dob) => {
    if (!dob) return "-";
    return moment().diff(moment(dob), "years");
});

Vue.filter("date", (date, defaultVal = "") => {
    if (!date) return defaultVal;
    return moment(date).format(dateFormat);
});

Vue.filter("datetime", (date, defaultVal = "") => {
    if (!date) return defaultVal;
    return moment(date).format(`${dateFormat} HH:mm`);
});

Vue.filter("gender", (gender) => {
    if (!gender) {
        return "-";
    }

    if (gender == "male") {
        return "Pria";
    }

    return "Wanita";
});

Vue.filter("get", (obj, prop, defaultVal) => {
    return _.get(obj, prop, defaultVal);
});

Vue.filter("int", (number) => {
    if (typeof number === "undefined" || number === null) {
        return `0`;
    }

    return new Intl.NumberFormat("id").format(parseInt(number));
});

Vue.filter("nl2br", (str) => {
    if (typeof str === "undefined" || str === null) {
        return "";
    }
    return (str + "").replace(
        /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
        "$1" + "<br />" + "$2"
    );
});

Vue.filter("number", (number) => {
    if (typeof number === "undefined" || number === null) {
        return `0`;
    }

    return new Intl.NumberFormat("id").format(number);
});

Vue.filter("price", (price, currency = "Rp") => {
    if (typeof price === "undefined" || isNaN(price) || price === null) {
        return `${currency}. 0`;
    }

    const precision = 2;
    return `${currency}. ${new Intl.NumberFormat("id").format(
        round(price, precision)
    )}`;
});
